<div data-test="YDv5Vig_" class="form-group__field-append">
  <button
    data-test="offhmgUg"
    class="link-light"
    type="button"
    (click)="handleToggle($event)"
  >
    <ng-container *ngIf="!showInvisButton">
      <i data-test="KxxYyhGu" class="material-icons">visibility_off</i>
    </ng-container>
    <ng-container *ngIf="showInvisButton">
      <i data-test="O3lVl-sa" class="material-icons">visibility</i>
    </ng-container>
  </button>
</div>
